import { DynamicStandaloneBylineGroup } from '@/components/BylineGroup';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorBylineGroup: LabradorComponent = ({ type, data, meta, descendants }) => {
  // TODO: Check descendants for an image. If there is one, use that instead of the default one

  return (
    <DynamicStandaloneBylineGroup
      bylines={data.bylines}
      options={data.options}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorBylineGroup;
